import SEO from "../../components/SEO";
import banner from "../../assets/img/asset7.png";

export const AboutPage = () => {

	return (
		<div className="w-full min-h-screen flex flex-col relative bg-gradient-to-br from-cyan-100 to-fuchsia-200 "><SEO title="About Us" description="Learn about Parcelin - eco-friendly parcel delivery across South Africa. We use vehicles already on the road to deliver your parcels affordably." path="/about-us" />
			<div className="grid grid-cols-1 gap-4 lg:grid-cols-2 py-10">
				<div className="flex justify-center flex-col gap-4 p-5 md:p-10">
                    <div className="flex flex-wrap items-center rounded-md">
                        <div className="text-center border-dashed border-2 border-slate-200 dark:border-slate-100 rounded-md w-full p-10 md:p-20 bg-white/50">
                            <i className='bx bxs-contact bx-lg mb-5 dark:text-white'></i>
                            <p className="text-xl mb-2 uppercase font-bold dark:text-gray">Who are we, you ask.</p>
                            <span className="text-m text-slate-700 block mb-10 dark:text-slate-500">
								Yet Another <a href="https://liftsearch.co.za" className="text-purple-600 font-semibold hover:text-purple-700" target="_blank" rel="noopener noreferrer">Liftsearch</a> innovation. 
								Parcelin is born out of the demand for reliable and cheaper same day parcel delivery in South Africa. 
								Starting in Limpopo (Polokwane, Giyani, Malamulele, Tzaneen, Bungeni, Thohoyandou and Phalaborwa) and All of Gauteng, it is the fastest growing long distance parcel delivery app.
							</span>
                            <a href="/" className="inline-block bg-purple-600 rounded-full px-5 py-3 text-white hover:bg-purple-700 transition-colors">Start Parcelin</a>
                        </div>
                    </div>
				</div>
				<div className="flex justify-center flex-col ">
					<div className="text-center py-6 px-6 lg:px-8 lg:py-8">
						<div className="text-purple-800 text-3xl md:text-4xl font-semibold">Revolutionizing Long Distance Parcel Delivery, One Parcel At A Time.</div>
					</div>
					<div className="flex items-center justify-center">
						<img className="h-96" src={banner} alt="Parcelin - Eco-friendly parcel delivery" />
					</div>
				</div>
			</div>

			{/* Environmental Impact Section */}
			<div className="w-full bg-white py-16 px-5">
				<div className="max-w-6xl mx-auto">
					<div className="text-center mb-12">
						<h2 className="text-3xl md:text-4xl font-bold text-purple-800 mb-4">Delivering Sustainably</h2>
						<p className="text-lg text-gray-700 max-w-3xl mx-auto">
							At Parcelin, we're committed to reducing our environmental footprint by utilizing vehicles that are already on the road, 
							rather than adding more cars to our streets.
						</p>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
						<div className="flex flex-col items-center text-center p-6 bg-gradient-to-br from-green-50 to-emerald-100 rounded-xl">
							<div className="text-5xl mb-4">🌱</div>
							<h3 className="text-xl font-bold text-gray-800 mb-3">Reduced Emissions</h3>
							<p className="text-gray-700">
								By leveraging existing vehicles making trips anyway, we significantly reduce carbon emissions compared to traditional delivery services 
								that add dedicated vehicles to the road.
							</p>
						</div>

						<div className="flex flex-col items-center text-center p-6 bg-gradient-to-br from-blue-50 to-cyan-100 rounded-xl">
							<div className="text-5xl mb-4">🚗</div>
							<h3 className="text-xl font-bold text-gray-800 mb-3">Smart Route Optimization</h3>
							<p className="text-gray-700">
								We connect your parcels with drivers already traveling your route, maximizing vehicle capacity and minimizing unnecessary trips. 
								It's carpooling, but for packages.
							</p>
						</div>

						<div className="flex flex-col items-center text-center p-6 bg-gradient-to-br from-purple-50 to-fuchsia-100 rounded-xl">
							<div className="text-5xl mb-4">♻️</div>
							<h3 className="text-xl font-bold text-gray-800 mb-3">Sustainable Future</h3>
							<p className="text-gray-700">
								Every parcel delivered through Parcelin is a step toward a more sustainable future. Together, we're building a delivery network 
								that's better for South Africa and our planet.
							</p>
						</div>
					</div>

					<div className="mt-12 text-center bg-purple-50 p-8 rounded-xl">
						<h3 className="text-2xl font-bold text-purple-800 mb-4">Our Environmental Commitment</h3>
						<p className="text-gray-700 max-w-3xl mx-auto mb-6">
							Traditional delivery services contribute to traffic congestion and air pollution by adding more vehicles to already crowded roads. 
							Parcelin takes a different approach: we work with drivers who are already making the journey, turning empty seats and trunk space 
							into delivery opportunities. This means fewer vehicles on the road, less fuel consumption, and a smaller carbon footprint for every delivery.
						</p>
						<p className="text-gray-700 max-w-3xl mx-auto font-semibold">
							When you choose Parcelin, you're not just choosing convenience and affordability—you're choosing a greener way to send your parcels.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};
